<template>
  <div class="academicConferences">
    <div class="head">
      <div class="head-1">
        <img
          v-if="imgShow"
          src="../../assets/img/academicConferences/bgc.png"
        />
        <img v-else src="../../assets/img/academicConferences/bgc-y.png" />
      </div>
    </div>

    <!-- <div class="contents">
      <div class="contents-head">
        <div class="contents-head-box"></div>
        <div class="contents-head-text">
          {{ $t("i18n.upcomingHumanBrainForum") }}
        </div>
      </div>
      <div class="contents-box">
        <ul
          class="contents-ul"
          v-if="
            academicConferencesObj.data &&
            academicConferencesObj.data.upcoming &&
            academicConferencesObj.data.upcoming.length
          "
        >
          <li
            class="contents-ul-li"
            v-for="(item, index) in academicConferencesObj.data.upcoming"
            :key="index"
          >
            <div class="contents-ul-li-top">
              <div class="contents-ul-li-top-head">
                {{ item.title }}
              </div>
              <div class="contents-ul-li-top-box">
                <div class="contents-ul-li-top-box-time">
                  {{ item.contentMeeting.meeting_start_time }}
                </div>
                <div class="contents-ul-li-top-box-di">
                  {{ item.contentMeeting.meeting_tag }}
                </div>
              </div>
            </div>
            <div
              class="contents-ul-li-bottom"
              @click="academicConferencesClick(item)"
            >
              <div class="contents-ul-li-bottom-text">
                <div v-html="item.contentMeeting.content"></div>
              </div>
              <div class="contents-ul-li-bottom-chakan">
                <div>{{ $t("i18n.Seedetails") }}</div>
                <i class="el-icon-right" />
              </div>
            </div>
          </li>
        </ul>
        <div class="contents-box-right">
          <div class="contents-box-right-head">
            <div class="contents-box-right-head-box">
              <img src="../../assets/img/academicConferences/tushu.png" />
            </div>
            <div class="contents-box-right-head-text">
              {{ $t("i18n.Periodicals") }}123
            </div>
          </div>
          <div class="contents-box-right-box">
            <div class="contents-box-right-box-img">
              <img :src="imgURL + periodicalsObj.thumb" />
            </div>
            <div class="contents-box-right-box-gang"></div>
            <div
              class="contents-box-right-box-text"
              v-if="periodicalsObj.contentSingle"
            >
              <div v-html="periodicalsObj.contentSingle.content"></div>
            </div>
            <div
              class="contents-box-right-box-yuedu"
              @click="readAll(periodicalsObj.id)"
            >
              【{{ $t("i18n.Readall") }}】
            </div>
          </div>
        </div>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentchange"
          @prev-click="prevClick"
          @next-click="nextClick"
          :page-count="academicConferencesObj.last_page"
          :current-page.sync="page"
          hide-on-single-page
        >
        </el-pagination>
      </div>
    </div> -->

    <div class="content_info">
      <div class="content_left">
        <div class="content_box">
          <div
            class="content_item"
            v-if="
              academicConferencesObj &&
              academicConferencesObj.upcoming &&
              academicConferencesObj.upcoming.length
            "
          >
            <div class="content_head">
              <span class="block"></span>
              <span class="name">
                {{ $t("i18n.upcomingHumanBrainForum") }}
              </span>
            </div>
            <div class="upcoming_ul">
              <div
                class="content_li"
                v-for="(item, index) in academicConferencesObj.upcoming"
                :key="index"
                @click="academicConferencesClick(item)"
              >
                <div class="content_li_thumb">
                  <img :src="imgURL + item.thumb" />
                </div>
                <div class="content_li_left">
                  <div class="title">
                    {{ item.title }}
                  </div>
                  <div class="time">
                    {{ item.contentMeeting.meeting_start_time }}
                    {{ item.contentMeeting.meeting_end_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="content_item"
            v-if="
              academicConferencesObj &&
              academicConferencesObj.past &&
              academicConferencesObj.past.length
            "
          >
            <div class="content_head past_title">
              <span class="block"></span>
              <span class="name">{{ $t("i18n.pastHumanBrainForum") }}</span>
            </div>

            <div class="past_ul">
              <div
                class="content_li"
                v-for="(item, index) in academicConferencesObj.past"
                :key="index"
                @click="academicConferencesClick(item)"
              >
                <div class="content_li_thumb">
                  <img :src="imgURL + item.thumb" />
                </div>
                <div class="content_li_left">
                  <div class="title">
                    {{ item.title }}
                  </div>
                  <div class="time">
                    {{ item.contentMeeting.meeting_start_time }}
                    {{ item.contentMeeting.meeting_end_time }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="contents-box-right-head">
          <div class="contents-box-right-head-box">
            <img src="../../assets/img/academicConferences/tushu.png" />
          </div>
          <div class="contents-box-right-head-text">
            {{ $t("i18n.HumanBrainForumText") }}
          </div>
        </div>
        <div class="contents-box-right-box">
          <div class="contents-box-right-box-img">
            <img :src="imgURL + periodicalsObj.thumb" />
          </div>
          <div class="contents-box-right-box-gang"></div>
          <div
            class="contents-box-right-box-text"
            v-if="periodicalsObj.contentBase"
          >
            <div v-html="periodicalsObj.contentBase.content"></div>
          </div>
          <div
            class="contents-box-right-box-yuedu"
            @click="readAll(periodicalsObj.id)"
          >
            【{{ $t("i18n.Readall") }}】
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "academicConferences",
  data() {
    return {
      imgURL: "",
      page: 1, //页码
      list_row: 4, //条数
      academicConferencesObj: {},
      periodicalsObj: {},
      imgShow: true,
    };
  },
  created() {
    this.imgURL = localStorage.getItem("imgURL");
    this.getacademicConferences();
    this.getSingle();
    if (localStorage.getItem("Language") == "zh-cn") {
      this.imgShow = true;
    } else {
      this.imgShow = false;
    }
  },
  methods: {
    //获取列表
    async getacademicConferences() {
      const { data: data } = await this.$http.get("meeting/list", {
        params: {
          lang: localStorage.getItem("Language"), //切换中英文
          page: this.page,
          list_row: this.list_row,
          cate_id: "/academicConferences",
        },
      });
      this.academicConferencesObj = data.data;
    },
    //详情
    academicConferencesClick(item) {
      this.$router.push({
        path: "academicConferencesDeatils",
        query: {
          id: item.id,
        },
      });
    },
    //获取期刊
    async getSingle() {
      const { data: data } = await this.$http.get("/detail", {
        params: {
          id: "263",
          lang: "zh-cn",
        },
      });
      this.periodicalsObj = data.data;
    },
    //阅读全部
    readAll(item) {
      this.$router.push({
        path: "periodicals",
        query: {
          id: this.periodicalsObj.id,
        },
      });
    },
    //点击每一页
    currentchange(e) {
      this.page = e;
      setTimeout(() => {
        this.getacademicConferences();
      }, 500);
      // this.$Spin.show();
    },
    //上一页
    prevClick(e) {
      this.page = e;
      setTimeout(() => {
        this.getacademicConferences();
      }, 500);
      // this.$Spin.show();
    },
    //下一页
    nextClick(e) {
      this.page = e;
      setTimeout(() => {
        this.getacademicConferences();
      }, 500);
      // this.$Spin.show();
    },
  },
};
</script>
<style lang="less" scoped>
.academicConferences {
  .head {
    position: relative;
    .head-1 {
      width: 100%;
      height: 174px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .head-2 {
      width: 719px;
      height: 44px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  // 内容
  .content_info {
    padding: 28px 190px 130px;
    display: flex;
    .content_left {
      flex: 1;
      .content_box {
        padding-right: 66px;
      }
      .content_item {
        &:not(&:last-child) {
          margin-bottom: 50px;
        }
        .past_title {
          .block {
            background: #e8e8e8 !important;
          }
        }
        .content_head {
          position: relative;
          margin-bottom: 40px;
          .block {
            display: inline-block;
            width: 80px;
            height: 50px;
            background: #ff7474;
          }
          .name {
            position: absolute;
            left: 27px;
            bottom: -5px;
            font-size: 22px;
            font-weight: bold;
            color: #363636;
            line-height: 31px;
          }
        }

        .content_li {
          display: flex;
          &:not(&:last-child) {
            margin-bottom: 60px;
          }
          .content_li_thumb {
            width: 414px;
            height: 148px;
            margin-right: 60px;
            border-radius: 10px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
          }
          .content_li_left {
            flex: 1;
            background: #f7f8fa;
            border-radius: 10px;
            padding: 28px 20px;
            .title {
              font-size: 18px;
              font-weight: bold;
              color: #2d2d2d;
              line-height: 30px;
              margin-bottom: 21px;
            }
            .time {
              font-size: 13px;
              color: #bcbcbc;
              line-height: 17px;
            }
          }
        }
      }
    }
    .content_right {
      width: 30%;
      position: relative;
      padding-left: 50px;
      border-left: 1px solid #e8e8e8;
      .contents-box-right-head {
        position: relative;
        top: 0;
        left: -40px;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .contents-box-right-head-box {
          width: 28px;
          height: 24px;
          margin-right: 7px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .contents-box-right-head-text {
          font-size: 18px;
          color: #363636;
          font-weight: 600;
        }
      }
      .contents-box-right-box {
        background-color: #f7f8fa;
        padding: 35px 30px;
        border-radius: 11px;

        .contents-box-right-box-img {
          width: 306px;
          height: 354px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .contents-box-right-box-gang {
          width: 25px;
          height: 5px;
          background-color: #e06c55;
          margin-top: 50px;
          margin-bottom: 20px;
        }
        .contents-box-right-box-text {
          width: 320px;
          color: #2d2d2d;
          font-size: 15px;
          line-height: 1.5;
          margin-bottom: 22px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 11;
          overflow: hidden;
        }
        .contents-box-right-box-yuedu {
          text-align: right;
          font-size: 16px;
          color: #e06c55;
          cursor: pointer;
        }
      }
    }
  }

  //内容
  .contents {
    padding: 0 190px;
    .contents-head {
      position: relative;
      margin-top: 28px;
      margin-bottom: 50px;
      .contents-head-box {
        position: absolute;
        width: 80px;
        height: 50px;
        background-color: #ff7474;
      }
      .contents-head-text {
        position: relative;
        top: 32px;
        left: 30px;
        color: #363636;
        font-size: 22px;
        font-weight: 600;
      }
    }

    .contents-box {
      display: flex;
      justify-content: space-between;
      .contents-ul {
        margin-right: 66px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 1107px;
        .contents-ul-li {
          position: relative;
          .contents-ul-li-top {
            position: relative;
            width: 463px;
            background-color: #f7f8fa;
            padding: 28px 30px 60px 28px;
            border-radius: 11px;
            .contents-ul-li-top-head {
              font-size: 18px;
              color: #2d2d2d;
              font-weight: 600;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .contents-ul-li-top-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 12px;
              .contents-ul-li-top-box-time {
                color: #bcbcbc;
                font-size: 13px;
              }
              .contents-ul-li-top-box-di {
                // width: 67px;
                min-width: 67px;
                padding: 0 5px;
                height: 35px;
                background-color: #7070b7;
                color: #fff;
                font-size: 13px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                // cursor: pointer;
              }
            }
          }
          .contents-ul-li-bottom {
            position: relative;
            top: -40px;
            left: 43px;
            width: 376px;
            padding: 22px 16px;
            border: 1px solid #e9e9e9;
            border-radius: 11px;
            font-size: 14px;
            color: #2d2d2d;
            background-color: #ffffff;
            z-index: 999;
            cursor: pointer;
            .contents-ul-li-bottom-text {
              line-height: 1.7;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 6;
              overflow: hidden;
            }
            .contents-ul-li-bottom-chakan {
              display: flex;
              align-items: center;
              margin-top: 30px;
              font-size: 14px;
              color: #ed6f56;
            }
          }
        }
      }
      //-----
      .contents-box-right {
        position: relative;
        padding-left: 50px;
        border-left: 1px solid #e8e8e8;
        .contents-box-right-head {
          position: relative;
          top: 0;
          left: -40px;
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          .contents-box-right-head-box {
            width: 28px;
            height: 24px;
            margin-right: 7px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .contents-box-right-head-text {
            font-size: 18px;
            color: #363636;
            font-weight: 600;
          }
        }
        .contents-box-right-box {
          background-color: #f7f8fa;
          padding: 35px 30px;

          .contents-box-right-box-img {
            width: 306px;
            height: 354px;
          }
          .contents-box-right-box-gang {
            width: 25px;
            height: 5px;
            background-color: #e06c55;
            margin-top: 50px;
            margin-bottom: 20px;
          }
          .contents-box-right-box-text {
            width: 320px;
            color: #2d2d2d;
            font-size: 15px;
            line-height: 1.5;
            margin-bottom: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 11;
            overflow: hidden;
          }
          .contents-box-right-box-yuedu {
            text-align: right;
            font-size: 16px;
            color: #e06c55;
            cursor: pointer;
          }
        }
      }
      //-----
    }

    .page {
      padding: 20px 0 55px 0;
      text-align: center;
      // /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      //   background-color: rgb(255, 116, 116);
      // }
      // /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
      //   color: rgb(255, 116, 116);
      // }
    }
  }
}
</style>
